import * as Sentry from '@sentry/browser';
import { onError } from '@apollo/client/link/error';
import { ApolloClient, InMemoryCache, HttpLink, from } from '@apollo/client';
import config from '../config';

const isBrowser = typeof window !== 'undefined';

if (isBrowser && process.env.SENTRY_DSN) {
  Sentry.init({ dsn: process.env.SENTRY_DSN });
}

const isAuthError = (graphQLErrors, networkError) =>
  networkError?.statusCode === 401 ||
  !!graphQLErrors?.some(
    ({ extensions }) => extensions?.category === 'authentication'
  );

const handleAuthError = () => {
  if (!isBrowser) return;

  document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  location.href = config.LOGIN_URL;
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      Sentry.captureException(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
          locations
        )}, Path: ${path}`
      );
    });
  }
  if (networkError) {
    Sentry.captureException(`[Network error]: ${networkError}`);
  }

  if (isAuthError(graphQLErrors, networkError)) handleAuthError();
});

const createApolloClient = ({ initialState = {}, jwt } = {}) => {
  const httpLink = new HttpLink({
    uri: config.GRAPHQL_URL,
    credentials: 'same-origin',
    headers: jwt ? { 'X-Authorization': `Bearer ${jwt}` } : {}
  });

  return new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache({
      typePolicies: { Me: { merge: true } }
    }).restore(initialState),

    devtools: {
      enabled: isBrowser && process.env.NODE_ENV === 'development'
    },

    ssrMode: !isBrowser
  });
};

let apolloClient = null;

export default (options) => {
  if (!isBrowser) {
    return createApolloClient(options);
  }
  if (!apolloClient) {
    apolloClient = createApolloClient(options);
  }
  return apolloClient;
};
